export const hamburger = `<svg width="32" height="10" viewBox="0 0 32 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="2" rx="1" fill="white"/>
<rect y="8" width="32" height="2" rx="1" fill="white"/>
</svg>
`;
